import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher: React.FC = () => {
  const { i18n, t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);

  const changeLanguage = (language: string): void => {
    i18n.changeLanguage(language);
  };

  function handleLanguageChange(language: string) {
    const confirm = window.confirm(t('languageSwitcher.confirmChange'));
    if(confirm) {
      changeLanguage(language);
      setIsOpen(false);
      window.location.reload();
    }
  }

  function renderFlag(language: string) {
    switch (language) {
      case 'pt-BR':
        return (
          <svg width="20" height="20" viewBox="0 0 512 512">
            <path fill="#009B3A" d="M0 256c0 141.384 114.616 256 256 256s256-114.616 256-256S397.384 0 256 0S0 114.616 0 256z"/>
            <path fill="#FEDF00" d="M256 100.174L467.478 256 256 411.826 44.522 256z"/>
            <circle fill="#002776" cx="256" cy="256" r="89.043"/>
            <path fill="#fff" d="M256 167.304c-52.566 0-95.305 42.739-95.305 95.305s42.739 95.305 95.305 95.305 95.305-42.739 95.305-95.305-42.739-95.305-95.305-95.305zm0 31.826c34.973 0 63.478 28.505 63.478 63.478s-28.505 63.478-63.478 63.478-63.478-28.505-63.478-63.478 28.505-63.478 63.478-63.478z"/>
          </svg>
        );
      case 'en':
        return (
          <svg width="20" height="20" viewBox="0 0 512 512">
            <path fill="#F0F0F0" d="M0 256c0 141.384 114.616 256 256 256s256-114.616 256-256S397.384 0 256 0 0 114.616 0 256z" />
            <path fill="#D80027" d="M244.87 256H512c0-23.106-3.08-45.49-8.819-66.783H244.87V256zm0-133.565h229.556c-15.671-25.572-35.708-48.175-59.07-66.783H244.87v66.783zM256 512c60.249 0 115.626-20.824 159.356-55.652H96.644C140.374 491.176 195.751 512 256 512zM37.574 389.565h436.852c12.581-20.529 22.338-42.969 28.755-66.783H8.819c6.417 23.814 16.174 46.254 28.755 66.783z" />
            <path fill="#0052B4" d="M118.584 39.978h23.329l-21.7 15.765 8.289 25.509-21.699-15.765-21.699 15.765 7.16-22.037C73.158 75.13 56.412 93.776 42.612 114.552h7.475l-13.813 10.035c-2.152 3.59-4.216 7.237-6.194 10.938l6.596 20.301-12.306-8.941c-3.059 6.481-5.857 13.108-8.372 19.873l7.267 22.368h26.822l-21.7 15.765 8.289 25.509-21.699-15.765-12.998 9.444C0.678 234.537 0 245.189 0 256h256V0h-9.043L256 18.247l-21.699-15.765-21.699 15.765 8.289 25.509-21.699-15.765-21.699 15.765 8.289 25.509-21.699-15.765-21.699 15.765 8.289 25.509-21.699-15.765z" />
          </svg>
        );
      case 'es':
        return (
          <svg width="20" height="20" viewBox="0 0 512 512">
            <path fill="#C60B1E" d="M0 256c0 141.384 114.616 256 256 256s256-114.616 256-256-114.616-256-256-256S0 114.616 0 256z"/>
            <path fill="#FFC400" d="M0 256c0 89.043 0-89.043 0 0zm0 0c0 141.384 114.616 256 256 256s256-114.616 256-256H0z"/>
            <path fill="#C60B1E" d="M0 256h512c0-89.043-114.616-256-256-256S0 166.957 0 256z"/>
          </svg>
        );
    }
  }

  return (
    <div className="relative z-[20]">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center gap-2 px-1 py-1 bg-cinza-100 border rounded-lg shadow-sm hover:bg-gray-50"
      >
        {renderFlag(i18n.language)}
      </button>

      {isOpen && (
        <div className="absolute left-0 mt-2 py-2 w-48 bg-white rounded-lg shadow-xl border">
          <button
            onClick={() => {
              handleLanguageChange('pt-BR');
            }}
            className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            {renderFlag('pt-BR')}
            Português
          </button>
          <button
            onClick={() => {
              handleLanguageChange('en');
            }}
            className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            {renderFlag('en')}
            English
          </button>
          <button
            onClick={() => {
              handleLanguageChange('es');
            }}
            className="flex items-center gap-2 w-full px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
          >
            {renderFlag('es')}
            Español
          </button>
        </div>
      )}
    </div>
  );
};

export default LanguageSwitcher; 